import { jsxs as $, Fragment as U, jsx as B } from "react/jsx-runtime";
import { zIndices as D } from "@fcamna/shared-component-foundations";
import { c as g } from "./index-65016bfa.mjs";
import { useRef as I, useState as C, useMemo as j, useEffect as F, useCallback as d } from "react";
import { createPortal as q } from "react-dom";
import b, { css as P } from "styled-components";
import { u as v } from "./usePopoverIndex-b3a93ecd.mjs";
import { u as Q } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { u as J } from "./useSlots-a1aa6a84.mjs";
import { u as K } from "./useWindowSize-88e90e04.mjs";
import { g as V } from "./getElementPosition-a8642645.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
var o = /* @__PURE__ */ ((t) => (t.AUTO = "auto", t.TOP = "top", t.BOTTOM = "bottom", t.LEFT = "left", t.RIGHT = "right", t.TOP_START = "top-start", t.TOP_END = "top-end", t.BOTTOM_START = "bottom-start", t.BOTTOM_END = "bottom-end", t.RIGHT_START = "right-start", t.RIGHT_END = "right-end", t.LEFT_START = "left-start", t.LEFT_END = "left-end", t))(o || {});
const w = b.div`
  &.Tooltip {
    ${({
  theme: {
    components: { tooltip: t }
  }
}) => P(t.Tooltip)};
  }
`, X = b.div`
  &.Tooltip__content-wrapper {
    ${({
  theme: {
    components: { tooltip: t }
  }
}) => P(t.ContentWrapper)};
  }
`, Y = b.div`
  &.Tooltip__content {
    ${({
  theme: {
    components: { tooltip: t }
  }
}) => P(t.Content)};
  }
`, Z = b.span`
  &.Tooltip__pointer {
    ${({
  theme: {
    components: { tooltip: t }
  }
}) => P(t.Pointer)};
  }
`, x = (t, a, f, y) => {
  const T = t.getBoundingClientRect(), c = a.clientHeight + 1, n = a.clientWidth + 1, s = T.top < c, i = T.left < n, r = T.right + n > f - 1, e = T.bottom + c > y - 1, l = s && r, E = s && i, S = e && i, R = e && r;
  if (!(!s && !r && !i && !e))
    return !s && !r && !i ? o.TOP : S && !s && !r ? o.TOP_END : R && !s && !i ? o.TOP_START : !e && !r && !i ? o.BOTTOM : E && !e && !r ? o.BOTTOM_END : l && !e && !i ? o.BOTTOM_START : r && !i ? o.LEFT : !r && i ? o.RIGHT : o.TOP;
};
function G({
  title: t,
  children: a,
  placement: f = o.AUTO,
  ariaLabel: y = "Tooltip",
  className: T,
  isDisabled: c,
  exceedOverflow: n = !1,
  ...s
}) {
  const i = Q({ label: "Tool Tip" }), r = I(null), e = I(null), l = I(null), [E, S] = C({}), { width: R, height: H } = K(), [u, A] = C(!1), L = v(u, G.zIndex), m = j(() => f === "above" ? o.TOP : f === "below" ? o.BOTTOM : f, [f]), [p, W] = C(
    m === o.AUTO ? o.TOP : m
  );
  F(() => {
    W(m === o.AUTO ? o.TOP : m);
  }, [m]);
  const z = d(() => {
    if (!r.current || !e.current || n)
      return;
    const h = x(r.current, e.current, R, H);
    h && h !== p && W(h);
  }, [n, p, H, R]);
  F(() => {
    u && z();
  }, [u, z]);
  const M = d(() => {
    l.current && (clearTimeout(l.current), l.current = null);
  }, []), _ = d(() => {
    if (!c) {
      if (!n) {
        if (!e.current)
          return;
        e.current.style.display = "block";
      }
      M(), A(!0);
    }
  }, [M, n, c]), O = d(() => {
    c || (M(), n || (l.current = setTimeout(() => {
      e.current && (e.current.style.display = "none");
    }, 300), A(!1)), n && (l.current = setTimeout(() => {
      A(!1);
    }, 100)));
  }, [M, n, c]), N = d(() => {
    if (!u || !n)
      return S({});
    const h = V(r, e, p, "tooltip");
    S(h);
  }, [n, u, p]);
  F(() => N(), [N]), J("scroll", N, void 0, !0);
  const k = () => /* @__PURE__ */ $(
    X,
    {
      ref: e,
      role: "tooltip",
      "aria-hidden": !u,
      "aria-label": y,
      onMouseOver: _,
      onMouseOut: O,
      className: g([
        "Tooltip__content-wrapper",
        `Tooltip__content-wrapper--${p}`,
        `${n && "Tooltip__content-wrapper--exceed"}`,
        {
          [`Tooltip__content-wrapper--${p}-open`]: u,
          "Tooltip__content-wrapper--open": u
        }
      ]),
      style: n ? { ...E, zIndex: L, display: "block" } : { zIndex: L, display: "none" },
      children: [
        /* @__PURE__ */ B(Y, { className: g(["Tooltip__content"]), children: t }),
        /* @__PURE__ */ B(Z, { className: g(["Tooltip__pointer", `Tooltip__pointer--${p}`]) })
      ]
    }
  );
  return n ? /* @__PURE__ */ $(U, { children: [
    /* @__PURE__ */ B(
      w,
      {
        className: g(["Tooltip", `Tooltip--${p}`, T]),
        ...s,
        ...i,
        ref: r,
        onMouseOver: _,
        onMouseOut: O,
        onFocus: _,
        onBlur: O,
        children: a
      }
    ),
    !!t && q(k(), document.body)
  ] }) : /* @__PURE__ */ $(
    w,
    {
      className: g(["Tooltip", `Tooltip--${p}`, T]),
      ...s,
      ...i,
      ref: r,
      onMouseOver: _,
      onMouseOut: O,
      onFocus: _,
      onBlur: O,
      children: [
        a,
        !!t && k()
      ]
    }
  );
}
G.zIndex = D.tooltip;
export {
  G as Tooltip
};
